/* TNC 13 Nights of Halloween hero: picks the state from the VISITOR'S clock (Shopify caches pages,
   so a server-side time check would lag). The server renders the section hidden; this script reveals it.
     live   : start <= now <= end (end is inclusive to the second, e.g. 06:59:59Z)  -> that night, counts to end
     teaser : between one night's end and the next night's start                     -> next night, counts to its start
     off    : before Night 1 starts or after Night 13 ends                            -> nothing (normal hero shows)
   Testing only: ?tnc_now=2026-10-19T18:00:00Z pins the clock to that instant (it keeps ticking from there). */
(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else root.TNC13N = api;
  if (typeof document !== 'undefined') api.boot();
})(typeof self !== 'undefined' ? self : this, function () {
  'use strict';

  function parse(iso) {
    var t = Date.parse(String(iso || '').trim());
    return isNaN(t) ? null : t;
  }

  /* nights: [{night, start, end}] with ISO strings or ms. Returns {mode, night, target} (target = ms the countdown hits 0). */
  function state(nights, now) {
    var list = [];
    for (var i = 0; i < nights.length; i++) {
      var s = typeof nights[i].start === 'number' ? nights[i].start : parse(nights[i].start);
      var e = typeof nights[i].end === 'number' ? nights[i].end : parse(nights[i].end);
      if (s !== null && e !== null && e >= s) list.push({ night: nights[i].night, start: s, stop: e + 1000, ref: nights[i] });
    }
    list.sort(function (a, b) { return a.start - b.start; });
    if (!list.length || now < list[0].start || now >= list[list.length - 1].stop) return { mode: 'off', night: null, target: null };
    for (var j = 0; j < list.length; j++) {
      if (now >= list[j].start && now < list[j].stop) return { mode: 'live', night: list[j].ref, target: list[j].stop };
      if (now < list[j].start) return { mode: 'teaser', night: list[j].ref, target: list[j].start };
    }
    return { mode: 'off', night: null, target: null };
  }

  function clockOffset() {
    try {
      var p = new URLSearchParams(window.location.search).get('tnc_now');
      var t = parse(p);
      return t === null ? 0 : t - Date.now();
    } catch (e) { return 0; }
  }

  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function attentive() {
    var a = window.__attentive;
    return a && typeof a.trigger === 'function' ? a : null;
  }

  /* Teaser sign-up button (only rendered with data-signup in sign-up mode): Attentive pop-up when Attentive is on the
     page and a creative ID is set, else the sign-up URL, else the fallback label + link. Re-run once the page loads,
     because Attentive's tag usually arrives after this script. */
  function resolveSignup(a) {
    var id = a.getAttribute('data-attentive-id'), url = a.getAttribute('data-signup-href');
    var on = (id && attentive()) || url;
    a.querySelector('.tnc13n-cta-label').textContent = a.getAttribute(on ? 'data-signup-label' : 'data-fallback-label');
    a.setAttribute('href', url || a.getAttribute('data-fallback-href'));
  }

  function mount(el) {
    if (el.getAttribute('data-tnc13n-ready')) return;
    el.setAttribute('data-tnc13n-ready', '1');
    var offset = clockOffset();
    var blocks = Array.prototype.slice.call(el.querySelectorAll('.tnc13n-nb'));
    var nights = blocks.map(function (b) {
      return { night: Number(b.getAttribute('data-night')), start: b.getAttribute('data-start'), end: b.getAttribute('data-end'), el: b };
    });
    var wrap = el.closest ? el.closest('.shopify-section') : null;
    var hideNext = el.getAttribute('data-hide-next') === 'true' && wrap && wrap.id;
    var styleId = 'tnc13n-hide-' + (wrap && wrap.id ? wrap.id : 'x');
    var forced = null, key = '', timer = null;

    function setHideNext(on) {
      if (!hideNext) return;
      var s = document.getElementById(styleId);
      if (on && !s) {
        s = document.createElement('style');
        s.id = styleId;
        s.textContent = '#' + (window.CSS && CSS.escape ? CSS.escape(wrap.id) : wrap.id) + ' + .shopify-section{display:none!important}';
        document.head.appendChild(s);
      } else if (!on && s) s.parentNode.removeChild(s);
    }

    function paint(now) {
      var st = forced ? { mode: 'live', night: forced, target: null } : state(nights, now);
      var k = st.mode + ':' + (st.night ? st.night.night + '@' + st.night.start : '');  /* start in the key: Night 13 has two blocks (Fri, Sat) */
      if (k !== key) {
        key = k;
        blocks.forEach(function (b) { b.classList.remove('is-active', 'is-teaser'); });
        if (st.mode === 'off') {
          el.hidden = true;
          setHideNext(false);
        } else {
          var b = st.night.el;
          b.classList.add('is-active');
          if (st.mode === 'teaser') b.classList.add('is-teaser');
          var img = b.querySelector('.tnc13n-photo img');
          if (img) img.loading = 'eager';
          el.hidden = false;
          setHideNext(true);
        }
      }
      if (st.mode === 'off') return;
      var left = st.target === null ? 0 : Math.max(0, Math.floor((st.target - now) / 1000));
      var t = st.night.el.querySelector('.tnc13n-timer');
      if (t) {
        t.hidden = st.target === null;
        t.querySelector('[data-t=h]').textContent = pad(Math.floor(left / 3600));
        t.querySelector('[data-t=m]').textContent = pad(Math.floor((left % 3600) / 60));
        t.querySelector('[data-t=s]').textContent = pad(left % 60);
      }
    }

    var signups = Array.prototype.slice.call(el.querySelectorAll('a[data-signup]'));
    var resolveAll = function () { signups.forEach(resolveSignup); };
    resolveAll();
    window.addEventListener('load', function () { resolveAll(); setTimeout(resolveAll, 3000); });
    el.addEventListener('click', function (ev) {
      var a = ev.target.closest && ev.target.closest('a[data-signup]');
      var id = a && a.getAttribute('data-attentive-id');
      if (!id || !attentive()) return;
      ev.preventDefault();
      attentive().trigger(null, null, null, id);
    });

    function tick() { paint(Date.now() + offset); }
    tick();
    timer = setInterval(tick, 1000);

    /* Theme editor: selecting a block previews it as live, deselecting returns to the clock. */
    el.addEventListener('tnc13n:force', function (ev) {
      var n = ev.detail;
      forced = null;
      for (var i = 0; i < nights.length; i++) if (nights[i].el === n) forced = nights[i];
      key = '';
      tick();
    });
    el._tnc13nStop = function () { clearInterval(timer); setHideNext(false); };
  }

  function boot() {
    var run = function () { Array.prototype.forEach.call(document.querySelectorAll('[data-tnc13n]'), mount); };
    run();
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
    document.addEventListener('shopify:section:load', run);
    document.addEventListener('shopify:section:unload', function (e) {
      var el = e.target && e.target.querySelector && e.target.querySelector('[data-tnc13n]');
      if (el && el._tnc13nStop) el._tnc13nStop();
    });
    document.addEventListener('shopify:block:select', function (e) {
      var b = e.target;
      if (!b || !b.classList || !b.classList.contains('tnc13n-nb')) return;
      var el = b.closest('[data-tnc13n]');
      if (el) el.dispatchEvent(new CustomEvent('tnc13n:force', { detail: b }));
    });
    document.addEventListener('shopify:block:deselect', function (e) {
      var el = e.target && e.target.closest && e.target.closest('[data-tnc13n]');
      if (el) el.dispatchEvent(new CustomEvent('tnc13n:force', { detail: null }));
    });
  }

  return { state: state, parse: parse, boot: boot };
});
